export function decimalFormat(number: number): number {
  return Number(number.toFixed(2));
}

export function isValidPositiveFloatNumber(input: string): boolean {
  const number = toFloat(input);
  return !isNaN(number) && number > 0;
}

export function toFloat(input: string): number {
  return parseFloat(input.replace(',', '.'));
}

export const parseDecimal = (v?: string): number | null => {
  if (!v || !v.trim()) return null;
  const n = Number(v.replace(',', '.'));
  return Number.isFinite(n) ? n : null;
};

export function toPositiveNumber(value: any) {
  const n = Number(String(value ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : NaN;
}